import React from 'react'
import classes from '../styles/Loader.module.scss'
import { SiTinder } from "react-icons/si"

const Loader = () => {
    return (
        <div className="loader-wrapper">
            <img src='/images/velocityprime_logo.png' className={classes.loader} alt='Logo loader' />
            <div className={classes.loader_text}>Loading..</div>
        </div>
    )
}

export default Loader